<template>
    <div>
        <div v-if="!hasError" class="s-search-results__list">
            <div v-for="(item, i) in results" :key="'search-result-' + i" class="s-search-results__item">
                <article class="b-article">
                    <div class="s-search-results__item__title">{{ item.title }}</div>
                    <div class="s-search-results__item__desc">
                        {{ item.description }}
                    </div>
                    <div class="s-search-results__item__link">
                        <a :href="item.href" class="dotted-link">{{ appData.dictionary.openLink }}</a>
                    </div>
                </article>
            </div>
        </div>
        <ResponseError v-else :error-messages="errorMessages" />
    </div>
</template>

<script>
import ResponseError from 'Root/vue/components/ResponseError.vue'

export default {
    components: {
        ResponseError,
    },

    props: {
        results: {
            type: Array,
            default() {
                return []
            },
        },
        errorMessages: {
            type: String,
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
